import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

/**
 * [AssignInfoInput] Example Input
 *  userId: String
 *  orderId: String
 */

const ASSIGN_PICKER = gql`mutation assignPicker($input: AssignInfoInput) {
  assignPicker(input: $input) {
    assignedAt
    status {label code}
    picker {
      firstName
      lastName
    }
    order {
      id
    }
  }
}
`

const AssignPicker = ({ children, ...props }) => {
  return (
    <MutationManager mutation={ASSIGN_PICKER} refetchQueries={['getAssignmentInfo']}>
      {({ data, loading, updateFn }) => children({ updateFn, loading, ...props })}
    </MutationManager>
  )
}

AssignPicker.propTypes = {
  children: PropTypes.any
}

export default AssignPicker
